import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { useAuthorizedFetch } from '@/lib/useAuthorizedFetch';

export interface NotificationItem {
  id: string;
  ticket_id: string | null;
  type: string;
  title: string;
  body: string;
  is_read: number;
  created_at: string;
}

export function useNotifications() {
  const authorizedFetch = useAuthorizedFetch();

  return useQuery({
    queryKey: ['notifications'],
    queryFn: () =>
      authorizedFetch<{ data: NotificationItem[]; meta: { unread_count: number } }>(
        '/v1/notifications',
      ),
    refetchInterval: 30_000,
    refetchOnWindowFocus: true,
  });
}

export function useMarkNotificationRead() {
  const authorizedFetch = useAuthorizedFetch();
  const qc = useQueryClient();

  return useMutation({
    mutationFn: (id: string) =>
      authorizedFetch(`/v1/notifications/${id}/read`, { method: 'PATCH' }),
    onSuccess: () => void qc.invalidateQueries({ queryKey: ['notifications'] }),
  });
}

export function useMarkAllNotificationsRead() {
  const authorizedFetch = useAuthorizedFetch();
  const qc = useQueryClient();

  return useMutation({
    mutationFn: () => authorizedFetch('/v1/notifications/read-all', { method: 'POST' }),
    onSuccess: () => void qc.invalidateQueries({ queryKey: ['notifications'] }),
  });
}
